module.exports = __webpack_public_path__ + "img/banner.ab7dc9f6.png";